module.exports = __webpack_public_path__ + "public/adc0550911288e8675691a1b3dabed9b.woff2";